import React from 'react'
import MemberDashboardModal from './MemberDashboardModal'
import MemberFrontDeskChat from './MemberFrontDeskChat'
import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'

/** The dashboard conversation presentation, shared by all Members entry points. */
export default function MemberFrontDeskModal({ clubCode, onClose }) {
  const { t } = useOptionalPrivanaI18n()
  return (
    <MemberDashboardModal
      labelledBy="contact-frontdesk-title"
      onClose={onClose}
      closeLabel={t('memberFrontDesk.close')}
      testId="contact-frontdesk-modal"
      size="dashboard"
    >
      <header className="mp-dashboard-modal__header">
        <h2 className="mp-panel-title" id="contact-frontdesk-title">{t('memberFrontDesk.title')}</h2>
      </header>
      <div className="mp-dashboard-modal__content-fill">
        <MemberFrontDeskChat clubCode={clubCode} />
      </div>
    </MemberDashboardModal>
  )
}
